import React from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import InternalLink from './InternalLink';
import getCityUrl from './getCityUrl';

const TypedLinks = props => {
  const contentTypes = props.types.map((type, index, types) => (
    <InternalLink
      key={type.name}
      text={trans(`search.others.${type.name}`)}
      url={getCityUrl(props.areaSlug, type.params)}
      hasComma={index + 1 < types.length}
    />
  ));

  return <div>{contentTypes}.</div>;
};

TypedLinks.propTypes = {
  types: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      params: PropTypes.string.isRequired
    })
  ),
  areaSlug: PropTypes.string.isRequired
};

TypedLinks.defaultProps = {
  types: []
};

export default TypedLinks;
